import type {
  PostPatentListFilterApiResponse,
  PostPatentListFilterResponse,
} from "@interface/patentList.interface";

export const adaptPatentListData = (
  response: PostPatentListFilterApiResponse,
): PostPatentListFilterResponse => ({
  page: response.page,
  size: response.size,
  totalPages: response.totalPages,
  total: response.total,
  data: response.data,
});
